// extracted by mini-css-extract-plugin
module.exports = {"background":"Modal_background__3Swuc","dialog":"Modal_dialog__YCYlv","close":"Modal_close__Uo0a8","view":"Modal_view__aSemM"};